import React from 'react';
import './DataSourcePage.css';
import {Link, Outlet} from 'react-router-dom';
import usePermissions from './hooks/usePermissions';

const AlertsPage: React.FC = () => {
    const {permissions} = usePermissions();

    const hasPermission = (requiredPermissions: string[]): boolean => {
        return requiredPermissions.some(permission => permissions.includes(permission));
    };

    const canViewAnyAlertMenu = hasPermission([
        'manage_media',
        'manage_credentials',
        'manage_snmp',
        'configure_api_source',
        'manage_zabbix_data_sources',
        'edit_value_mapping',
        'configure_metrics',
        'manage_api_keys',
        'manage_http_gateway',
    ]);

    return (
        <div className="data-source-page">
            <div className="data-source-container">
                <div className="data-source-sidebar">
                    <h2>Alert</h2>
                    {canViewAnyAlertMenu && (
                        <ul>
                            {hasPermission(['manage_media']) && (
                                <li>
                                    <Link to="/alerts/media" className="sub-menu-link">Media</Link>
                                </li>
                            )}

                            {hasPermission(['manage_credentials']) && (
                                <li>
                                    <Link to="/alerts/SnmpCredential" className="sub-menu-link">
                                        Snmp Credential
                                    </Link>
                                </li>
                            )}

                            {hasPermission(['manage_snmp']) && (
                                <li>
                                    <Link to="/alerts/snmpoid-manager" className="sub-menu-link">
                                        Snmp OID Manager
                                    </Link>
                                </li>
                            )}

                            {hasPermission(['configure_api_source']) && (
                                <li>
                                    <Link to="/alerts/apisource-config" className="sub-menu-link">
                                        Api Source Config
                                    </Link>
                                </li>
                            )}

                            {hasPermission(['manage_api_keys']) && (
                                <li>
                                    <Link to="/alerts/api-keys" className="sub-menu-link">
                                        API Keys
                                    </Link>
                                </li>
                            )}

                            {hasPermission(['manage_http_gateway']) && (
                                <li>
                                    <Link to="/alerts/http-gateway" className="sub-menu-link">
                                        HTTP Gateway
                                    </Link>
                                </li>
                            )}

                            {hasPermission(['manage_zabbix_data_sources']) && (
                                <li>
                                    <Link to="/alerts/zabbix-data-sources" className="sub-menu-link">
                                        Zabbix Data Sources
                                    </Link>
                                </li>
                            )}

                            {hasPermission(['edit_value_mapping']) && (
                                <li>
                                    <Link to="/alerts/value-mapping" className="sub-menu-link">
                                        Value Mapping
                                    </Link>
                                </li>
                            )}

                            {hasPermission(['configure_metrics']) && (
                                <li>
                                    <Link to="/alerts/metrics-config" className="sub-menu-link">
                                        Metric Config
                                    </Link>
                                </li>
                            )}


                        </ul>
                    )}
                </div>

                <div className="data-source-main-content">
                    <Outlet/>
                </div>
            </div>
        </div>
    );
};

export default AlertsPage;